import { render } from "./SalaryEdit.vue?vue&type=template&id=8e75cd4a"
import script from "./SalaryEdit.vue?vue&type=script&lang=js"
export * from "./SalaryEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__